"use client";
import { months } from "@/utils/utils";
import Image from "next/image";

type TimelineItem = {
  date: string;
  title: string;
  description: string;
};

type Props = {
  items: TimelineItem[];
};

export default function Timeline({ items }: Readonly<Props>) {
  return (
    <div className="relative w-full py-16">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-1 h-full bg-gray-300"></div>

      <div className="flex flex-col gap-16">
        {items.map((item, index) => {
          const isRight = index % 2 === 0;

          return (
            <div
              key={`${item.date}-${item.title}`}
              className={`
                flex items-center gap-6 relative
                ${isRight ? "justify-start" : "justify-end"}
              `}
            >
              <div className="absolute left-1/2 -translate-x-1/2 size-8 rounded-full bg-primary shadow-xl shadow-primary/40"></div>

              <div
                className={`
                  w-140 bg-white rounded-2xl shadow-lg p-5 border border-gray-100 flex gap-4
                  ${isRight ? "mr-20" : "ml-20"} 
                  ${isRight ? "" : "flex-row-reverse"} 
                `}
                dir="rtl"
              >
                <div className="relative size-40 shrink-0 overflow-hidden rounded-xl">
                  <Image
                    src={"/assets/jolly.jpg"}
                    alt={item.title}
                    fill
                    sizes="160px"
                    className="object-cover"
                  />
                </div>

                <div className="flex flex-col justify-center">
                  <h3 className="text-primary font-bold text-lg">{item.title}</h3>
                  <p className="text-gray-500 text-sm mt-1">{item.date.slice(-2)} {months[+item.date.slice(5, 7) - 1]} {item.date.slice(0, 4)}</p>
                  <p className="text-gray-700 mt-3 leading-[1.6] text-sm">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}